
<template>
  <v-app id="app">
    <v-main>
      <RouterView />
    </v-main>
  </v-app>
</template>
<script setup lang="ts">
  // pass
</script>
